import "@Styles/Shared/Youtube/videoOverlay_sm.less";
import "@Styles/Shared/Youtube/BC/videoOverlay_sm.less";
import "@Styles/Shared/Youtube/videoOverlay_md.less";
import "@Styles/Shared/Youtube/BC/videoOverlay_md.less";
/* istanbul ignore next */
var youtubeVideo = function youtubeVideo() {
  return import(
  /* webpackChunkName: "youtubeVideo" */
  './youtubeVideo');
},
    privacyMessage = function privacyMessage() {
  return import(
  /* webpackChunkName: "videoPrivacyMessage" */
  './videoPrivacyMessage');
};

import { hasPrivacyOptOut } from './_util';
import { PLAY_VIDEO_EVENT } from './_constants';
import modal from '@Shared/Common/Scripts/Components/modalBase';
export default {
  data: function data() {
    return {
      config: {},
      component: '',
      modalComponent: '',
      isModalVisible: false
    };
  },
  computed: {
    showPlayButton: function showPlayButton() {
      return this.component === '';
    }
  },
  components: {
    'youtubeVideo': youtubeVideo,
    'privacyMessage': privacyMessage,
    'modal': modal
  },
  methods: {
    init: function init(config) {
      var _this = this;

      this.config = config || {};
      this.modalComponent = 'modal'; // listen for custom event sent by the video watch button

      document.addEventListener(PLAY_VIDEO_EVENT, function (event) {
        return _this.$_scrollToVideo(event);
      });
    },
    focusModal: function focusModal() {
      this.$refs.videoModalHeader.focus();
    },
    showVideo: function showVideo() {
      this.component = hasPrivacyOptOut() ? 'privacyMessage' : 'youtubeVideo';
      this.setModalComponent();
    },
    hideVideo: function hideVideo() {
      this.component = '';
    },
    hideModal: function hideModal() {
      this.isModalVisible = false;
      this.component = '';
    },
    setModalComponent: function setModalComponent() {
      this.modalComponent = 'modal';
      this.isModalVisible = true;
    },
    $_scrollToVideo: function $_scrollToVideo(event) {
      if (event && event.detail === this.config.id) {
        this.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        this.showVideo();
      }
    }
  }
};